import { SubdivisionAuditList } from './views';

export default {
  list: SubdivisionAuditList,
  name: 'subdivision-audit',
  // No 'label' property = hidden from menu per react-admin Resource behavior
};
